import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfigApiService } from 'src/app/services/config-api.service';
import { InstructionService } from 'src/app/services/instruction.service';
import { LoadConfigService } from 'src/app/services/load-config.service';
import { RedirectionService, Status } from 'src/app/services/redirection.service';
import { StudyNavigationService } from 'src/app/services/study-navigation.service';
import { maxSelected } from 'src/app/shared/maxSelected.validator';
import { minSelected } from 'src/app/shared/minSelected.validator';
import { QuestionType, ScreeningQuestiionType } from 'src/app/shared/question';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-screening',
    templateUrl: './screening.component.html',
    styleUrls: ['./screening.component.scss'],
    standalone: false
})
export class ScreeningComponent implements OnInit {
  ScreeningFrom: FormGroup;
  rawQuestions: ScreeningQuestiionType[];
  studyPosition = 0;
  constructor(
    private navService: StudyNavigationService,
    private instructionService: InstructionService,
    private loadConfService: LoadConfigService,
    private fb: FormBuilder,
    private redirectionService: RedirectionService,
    private configApiService: ConfigApiService
  ) {}
  isLoading = false;
  onSubmit(event) {
    event.preventDefault();
    if (this.isUserEligible()) this.navService.renderNext();
    else {
      this.isLoading = true;
      this.redirectionService.setStatus(Status.terminate).subscribe(() => {
        window.location.href = environment.agencyTerminateDropoutURL.replace(
          'XXX',
          this.configApiService.getParams().RID
        );
        this.isLoading = false;
      });
    }
  }

  isUserEligible(): boolean {
    const formControlKeys = Object.keys(this.formControls);
    let isEligible = true;
    for (let i = 0; i < formControlKeys.length; i++) {
      const key = formControlKeys[i];
      const question = this.rawQuestions.find(q => q.questionID === key);
      if (!question) return true;
      const rule = question.rule.type;
      // This next code line is enough if only equal condition is needed to test (instead of the switch statement)
      //if (question && question.rule?.value.toString() !== this.formControls[key].value.toString()) return false;
      switch (rule) {
        case 'notEqual':
          if (
            question.rule.value.toString().toLocaleLowerCase().trim() ===
            this.formControls[key].value.toString().toLocaleLowerCase().trim()
          )
            isEligible = false;
          console.log('notEqual', isEligible);
          break;
        case 'equal':
          if (
            question.rule.value.toString().toLocaleLowerCase().trim() !==
            this.formControls[key].value.toString().toLocaleLowerCase().trim()
          )
            isEligible = false;
          break;
        case 'greaterThan':
          if (Number(question.rule.value) > Number(this.formControls[key].value)) isEligible = false;
          break;
        case 'lessThan':
          if (Number(question.rule.value) < Number(this.formControls[key].value)) isEligible = false;
          break;
      }
    }
    return isEligible;
  }

  private getValidatorsRaw(question: QuestionType) {
    const validators = [];
    if (!question.required) {
      return validators;
    }

    if (question.required) {
      validators.push(Validators.required);
    }

    if (question.type === 'checkbox') {
      validators.push(minSelected(question.minNumberSelected));
      validators.push(maxSelected(question.maxNumberSelected));
    }
    return validators;
  }
  buildForm() {
    this.ScreeningFrom = this.fb.group({});
    this.rawQuestions.forEach(question => {
      const validators = this.getValidatorsRaw(question);
      this.ScreeningFrom.addControl(question.questionID, this.fb.control('', validators));
    });
  }

  get formControls() {
    return this.ScreeningFrom.controls;
  }

  ngOnInit(): void {
    this.rawQuestions = this.loadConfService.getRawQuestions(
      this.instructionService.getLanguageIdentifier(),
      this.studyPosition,
      'screening'
    );
    this.buildForm();
  }

  /*   equalValidator(value: any): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const currentValue = control.value;
      if (currentValue !== value) {
        return { valueIsWrong: true };
      }
      return null;
    };
  }

  greaterThanValidator(value: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const currentValue = control.value;
      if (currentValue <= value) {
        return { valueIsWrong: true };
      }
      return null;
    };
  } */
}
